export const workloadsPaths = {
  absolute: '/:clientId/workloads',

  alertDetails: {
    absolute: '/:clientId/workloads/alert/:alertId',
    relative: 'alert/:alertId',
  },
} as const;

export const workloadsAlertsPaths = {
  absolute: '/:clientId/workloads-alerts',

  alertDetails: {
    absolute: '/:clientId/workloads-alerts/alert/:alertId',
    relative: 'alert/:alertId',
  },
} as const;
